/* src/app/features/contratacao/limite/limite-fundo-cadastro.component.scss */
form {
  margin-bottom: 60px;
}
.fa-question-circle {
  vertical-align: bottom;
}
.help-remove {
  margin-bottom: 4px;
}
.help-subtitulo {
  color: #495057;
  font-size: 1rem;
  vertical-align: middle;
}
.coluna-moeda {
  text-align: right;
}
.altura {
  padding-top: 1.2em;
}
.cor-verde {
  color: limegreen;
}
/*# sourceMappingURL=limite-fundo-cadastro.component.css.map */
